import Organization from "models/Organization";
import { ApplicationUser } from "models/Permission/ApplicationUser";

export default function initializePendo(
    user: ApplicationUser | undefined,
    organization: Organization | undefined,
) {
    const isDev = process.env.NODE_ENV === "development";
    if (isDev) {
        console.info(
            "Development environment detected. Pendo initialization is disabled.",
        );
        return;
    }

    // Disable pendo on automated tests
    if (navigator.webdriver) {
        console.info(
            "Automated environment detected. Pendo initialization is disabled.",
        );
        return;
    }

    // Guard against a missing user/organization. During impersonation the
    // impersonated identity's org/profile can fail to resolve; Pendo is analytics
    // only and must never break app initialization by dereferencing an undefined.
    if (!user?.id || !organization?.id) {
        console.warn(
            "Pendo initialization skipped: missing user or organization.",
        );
        return;
    }

    try {
        // This function creates visitors and accounts in Pendo
        // Please use Strings, Numbers, or Bools for value types.
        // @ts-ignore
        pendo.initialize({
            visitor: {
                id: user.id, // Required if user is logged in
                email: user.email, // Recommended if using Pendo Feedback, or NPS Email
                user_name: user.userName,
                statementOfWork: user.statementOfWork,
                // full_name:    // Recommended if using Pendo Feedback
                // role:         // Optional
            },

            account: {
                id: organization.id, // Highly recommended, required if using Pendo Feedback
                name: organization.name, // Acct Name = Organization Name
                // is_paying:    // Recommended if using Pendo Feedback
                // monthly_value:// Recommended if using Pendo Feedback
                // planLevel:    // Optional
                // planPrice:    // Optional
                // creationDate: // Optional
            },
        });
    } catch (e) {
        // Analytics failure must never abort dependency initialization.
        console.error("Pendo initialization failed; continuing without it.", e);
    }
}
